import MembersRoute_ from "../Components/Members/MembersRoute"
import AcceptInviteDialog_ from "./ContainerAcceptInviteDialog"
import AccountInfoSyncManager_ from "./ContainerAccountInfoSyncManager"
import ClansRating_ from "./ContainerBaseClansRating"
import { default as ChangeRoleOperationDialogContainer_ } from "./ContainerChangeRoleOperationDialog"
import ContainerClanBattles_ from "./ContainerClanBattles"
import ClanCreate_ from "./ContainerClanCreate"
import ClanEditDialogsContainer_ from "./ContainerClanEditDialogs"
import ClanLeaveDialogContainer_ from "./ContainerClanLeave"
import ContainerClanProfile_ from "./ContainerClanProfile"
import ClanWars_ from "./ContainerClanWars"
import Dialog_ from "./ContainerDialog"
import GlobalProcessing_ from "./ContainerGlobalProcessing"
import Layout_ from "./ContainerLayout"
import MonumentAchievementsDialog_ from "./ContainerMonumentAchievementsDialog"

import ContainerRecommendations_ from './ContainerRecommendations'
import ContainerClanTasks_ from './ContainerClanTasks'

import RecommendationsClanSettingsDialog_ from "./ContainerRecommendationsClanSettingsDialog"
import Requests_ from "./ContainerRequests"
import Search_ from "./ContainerSearch"
import SendApplicationDialog_ from "./ContainerSendApplicationDialog"
import ContainerTreasury_ from "./ContainerTreasury"

export const AcceptInviteDialog = AcceptInviteDialog_
export const AccountInfoSyncManager = AccountInfoSyncManager_
export const ChangeRoleOperationDialogContainer = ChangeRoleOperationDialogContainer_
export const ClanCreate = ClanCreate_
export const ClanEditDialogsContainer = ClanEditDialogsContainer_
export const ClanLeaveDialogContainer = ClanLeaveDialogContainer_
export const ClansRating = ClansRating_
export const Dialog = Dialog_
export const GlobalProcessing = GlobalProcessing_
export const Requests = Requests_
export const Layout = Layout_
export const MembersRoute = MembersRoute_
export const MonumentAchievementsDialog = MonumentAchievementsDialog_
export const RecommendationsClanSettingsDialog = RecommendationsClanSettingsDialog_
export const Search = Search_
export const SendApplicationDialog = SendApplicationDialog_
export const ClanWars = ClanWars_
export const ContainerClanBattles = ContainerClanBattles_
export const ContainerTreasury = ContainerTreasury_
export const ContainerClanProfile = ContainerClanProfile_
export const ContainerRecommendations = ContainerRecommendations_
export const ContainerClanTasks = ContainerClanTasks_
